export default __webpack_public_path__ + "static/ethereum-f40e502e65bbf79987a67bcc111d7e85.svg";